import type { Color } from '@/types/Color'
import type { UUID } from '@/types/Id'

export type TagType =
  | 'pursuit'
  | 'organization'
  | 'pursuit_folder'
  | 'organization_folder'

export const CONVENTIONAL_TAG_TYPES: TagType[] = ['organization', 'pursuit']
export const FOLDER_TAG_TYPES: TagType[] = [
  'organization_folder',
  'pursuit_folder',
]

export interface Tag {
  id: UUID
  created_at: string // ISO 8601
  last_modified: string // ISO 8601
  name: string
  description: string
  color: Color
  type: TagType
  organization_id: UUID
  user_id: UUID | null
  parent_id: UUID | null
  pursuit_id: UUID | null
  position: number | null
}

export interface CreateTag {
  name: string
  description: string
  color: Color
  type?: TagType
  parent_id?: UUID | null
  pursuit_id?: UUID | null
  position?: number | null
}

export interface CreateTags {
  tags: CreateTag[]
}

export interface BulkCreateOrganizationFoldersRequest {
  base_folder_id?: UUID | null
  color?: Color
  paths: string[][]
}

export interface BulkCreateOrganizationFoldersResponse {
  created_count: number
  created_folder_ids: UUID[]
  reused_existing_folder_count: number
  total_requested_paths: number
}

export interface BulkCreatePursuitFoldersRequest {
  base_folder_id?: UUID | null
  color?: Color
  paths: string[][]
}

export interface BulkCreatePursuitFoldersResponse {
  created_count: number
  created_folder_ids: UUID[]
  reused_existing_folder_count: number
  total_requested_paths: number
}

export interface UpdateTag {
  id: UUID
  name?: string
  description?: string
  color?: Color
  parent_id?: UUID | null
  pursuit_id?: UUID | null
  clear_parent?: boolean
  position?: number | null
}
